import useSelectedMasterProject from '../hooks/useSelectedMasterProject';
import DescripcionesSection from '../ui/DescripcionesSection';

const DescripcionesTab = () => {
  const { data: master, isError, isLoading, selectedId } = useSelectedMasterProject();

  if (selectedId == null) {
    return (
      <section>
        <p className="text-sm text-text-muted">Selecciona una inmobiliaria desde el sidebar.</p>
      </section>
    );
  }

  if (isLoading || !master) {
    return (
      <section>
        <p className="text-sm text-text-muted">Cargando...</p>
      </section>
    );
  }

  if (isError) {
    return (
      <section>
        <p className="text-sm text-destructive">No se pudo cargar las descripciones.</p>
      </section>
    );
  }

  return <DescripcionesSection project={master} />;
};

export default DescripcionesTab;
